import convert from './convert';
import displayPrice from './displayPrice';

const getSimplePrice = (options) => {
    let price = options.price;
    if (price === 0) {
        return 0;
    }

    let currentCurrency = 'EUR';
    if (typeof options.currentCurrency !== 'undefined') {
        currentCurrency = options.currentCurrency;
    }

    let originalCurrency = 'EUR';
    if (typeof options.originalCurrency !== 'undefined') {
        originalCurrency = options.originalCurrency;
    }

    let lang = 'fr';
    if (typeof options.lang !== 'undefined') {
        lang = options.lang;
    }

    let convertPrice = true;
    if (typeof options.convertPrice !== 'undefined') {
        convertPrice = options.convertPrice;
    }

    let currencies = [];
    if (typeof options.currencies !== 'undefined') {
        currencies = options.currencies;
    }

    let showCurrencyText = false;
    if (typeof options.showCurrencyText !== 'undefined') {
        showCurrencyText = options.showCurrencyText;
    }

    let business = false;
    if (typeof options.business !== 'undefined') {
        business = options.business;
    }

    if (currentCurrency === originalCurrency) {
        price = displayPrice(
            business,
            price,
            lang,
            currentCurrency,
            originalCurrency,
            currencies,
            convertPrice,
        );

        return price;
    }

    price = `${displayPrice(
        business,
        price,
        lang,
        originalCurrency,
        originalCurrency,
        currencies,
        convertPrice,
    )} (${displayPrice(
        business,
        price,
        lang,
        currentCurrency,
        originalCurrency,
        currencies,
        convertPrice,
    )})`;

    return price;
};

export default getSimplePrice;
